<div class="container-xxl container-fluid gx-0">
    <div id="metrix-configurator"></div>
</div>
